// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-outline-primary {
    color: #358696;
    border-color: #358696;
}

.btn-outline-primary:hover,
.btn-outline-primary:focus,
.btn-outline-primary:visited,
.btn-outline-primary:active,
.btn-check:checked+.btn,
.btn.active,
.btn.show,
.btn:first-child:active,
:not(.btn-check)+.btn:active {
    background-color: #358696;
    color: #fff;
}

.btn:hover {
    color: var(--bs-btn-hover-color);
    background-color: #358696;
    border-color: #358696;
}

.btn-primary {
    --bs-btn-color: #fff;
    --bs-btn-bg: #358696;
    --bs-btn-border-color: #358696;
    --bs-btn-hover-color: #fff;
    --bs-btn-hover-bg: #358696;
    --bs-btn-hover-border-color: #358696;
    --bs-btn-focus-shadow-rgb: 49, 132, 253;
    --bs-btn-active-color: #fff;
    --bs-btn-active-bg: #358696;
    --bs-btn-active-border-color: #358696;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #fff;
    --bs-btn-disabled-bg: #358696;
    --bs-btn-disabled-border-color: #358696;
}

.form-check-input:checked {
    background-color: #358696;
    border-color: #358696;
}

.form-select:focus {
    border-color: #358696;
    outline: 0;
    box-shadow: 0 0 0 0.25rem rgb(53 134 150 / 23%);
}

/* Tabs Section */
.nav-link:focus,
.nav-link:hover {
    /* color: var(--bs-nav-link-hover-color); */
    color: #358696;
}

.nav-link {
    color: #999;
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
    color: #358696;
    background-color: var(--bs-nav-tabs-link-active-bg);
    border-color: var(--bs-nav-tabs-link-active-border-color);
}

/* Section Header<> */

.secHead34 {
    background-color: #d3eff4;
    padding: 10px;
    margin-bottom: 20px;
}

.bg-white {
    background-color: #fff;
}

.headBG {
    box-sizing: border-box;
    background: #FFFFFF;
    border: 1px solid #358696;
}

.mainDiv {
    margin-top: 80px;
}

.widget {
    background: #FFFFFF;
    box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.11);
}

.widgetIcon img {
    width: 50px;
    height: 50px;
}

.widgetIcon-32 img {
    width: 32px;
    height: 32px;
}

.sec2Charts .titlebg {
    font-size: 1.1em;
    color: #000;
    font-weight: 500;
    margin-bottom: 10px;
    text-align: left;
}

.titlebg {
    font-size: 1.2em;
    color: #000;
    font-weight: 500;
    margin-bottom: 10px;
    text-align: center;
}

.chart3Title {
    font-size: 1.2em;
    color: #000;
    font-weight: 500;
    text-align: left;
}

.chartbox {
    background: #FFFFFF;
    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
    padding: 10px;
    color: #353535;
    /* font-size: 14px; */
}

.chartbox3 {
    background: #FFFFFF;
    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
    padding: 10px;
    color: #353535;
    /* min-height: 495px; */
}

h5,
.h5 {
    font-size: 1.1rem !important;
}

p {
    line-height: 1rem !important;
}

small,
.small {
    font-size: 80% !important;
}

table tr td {
    font-size: 0.8em;
}

.accordion-button {
    font-size: 0.5em;
}

.accordion-button:not(.collapsed) {
    background-color: #e0e0e0;
    color: #222;
}

.filterForm>.form-label {
    font-size: 0.825em;
}

.form-label {
    font-size: 0.825em;
}

.Headfont {
    font-size: 1.8rem;
}

.dropdown-menu[data-bs-popper] {
    right: 0 !important;
    left: auto;
}

/***************************** PageTwo *******************************/
.bt-graph {
    border-right: solid 1px #b5b5b5;
}

.icon-rgt {
    /* width: 62%; */
    float: right;
}

.icon-rgt-top {
    font-size: 13px;
    width: 100%;
    padding: 5px 0px 2px 0px;
}

.fst1 {
    border-left: solid 2px #ffa650;
    float: right;
    margin-right: 10px;
    padding-left: 5px;
    font-size: 11px;
}

/* .icon-rgt-top {} */

.fst {
    border-left: solid 2px #ffa650;
    padding-left: 5px;
    /* font-size: 11px; */
    font-size: 12px;
}



/* media queries start here */

@media screen and (max-width: 991px) {
    .mgt-2 {
        margin-top: 20px;
    }
}

@media screen and (max-width: 740px) {
    .titlebg {
        font-size: 0.9em;
    }
}

@media screen and (max-width: 720px) {
    .mainDiv {
        margin-top: 124px;
    }
}

@media screen and (max-width: 480px) {
    .mainDiv {
        margin-top: 155px;
    }
}

@media screen and (max-width: 480px) {
    .topHeader h2 {
        font-size: 22px;
        padding-right: 3rem;
    }

    .titlebg {
        font-size: 0.9em;
    }
}

@media screen and (max-width: 320px) {
    .topHeader h2 {
        font-size: 16px;
        padding-right: 0rem;
    }
}

.boxHead {
    background: #D3EFF4;
    border-bottom: 1px solid #358696;
    padding: 5px;
    height: 30px;
    /* margin-bottom: 15px; */
    margin-top: 5px;
}

dl dt {
    display: inline-block;
    width: 5px;
    height: 15px;
    vertical-align: middle;
}

dl dd {
    display: inline-block;
    margin: 0px 5px;
    padding-bottom: 0;
    vertical-align: middle;
    font-size: 12px;
}

dl dt.red {
    background: #ffa344;
}

dl dt.yellow {
    background: #358696;
}

/* #chartdivBCS{
    width: 100%;
    height: 500px;
} */
.evfpr0{
    padding-right: 0px;
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard/Faultanalysis/FaultSecondPage/FaultSecondPageCustom.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;;;;;;;;;IASI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,gCAAgC;IAChC,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,8BAA8B;IAC9B,0BAA0B;IAC1B,0BAA0B;IAC1B,oCAAoC;IACpC,uCAAuC;IACvC,2BAA2B;IAC3B,2BAA2B;IAC3B,qCAAqC;IACrC,4DAA4D;IAC5D,6BAA6B;IAC7B,6BAA6B;IAC7B,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,+CAA+C;AACnD;;AAEA,iBAAiB;AACjB;;IAEI,2CAA2C;IAC3C,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,cAAc;IACd,mDAAmD;IACnD,yDAAyD;AAC7D;;AAEA,qBAAqB;;AAErB;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,wCAAwC;IACxC,aAAa;IACb,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,wCAAwC;IACxC,aAAa;IACb,cAAc;IACd,uBAAuB;AAC3B;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA,sEAAsE;AACtE;IACI,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA,qBAAqB;;AAErB;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,qBAAqB;IACrB,eAAe;AACnB;;;;AAIA,6BAA6B;;AAE7B;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,mBAAmB;IACvB;AACJ;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;IAChC,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;;GAGG;AACH;IACI,kBAAkB;AACtB","sourcesContent":[".btn-outline-primary {\r\n    color: #358696;\r\n    border-color: #358696;\r\n}\r\n\r\n.btn-outline-primary:hover,\r\n.btn-outline-primary:focus,\r\n.btn-outline-primary:visited,\r\n.btn-outline-primary:active,\r\n.btn-check:checked+.btn,\r\n.btn.active,\r\n.btn.show,\r\n.btn:first-child:active,\r\n:not(.btn-check)+.btn:active {\r\n    background-color: #358696;\r\n    color: #fff;\r\n}\r\n\r\n.btn:hover {\r\n    color: var(--bs-btn-hover-color);\r\n    background-color: #358696;\r\n    border-color: #358696;\r\n}\r\n\r\n.btn-primary {\r\n    --bs-btn-color: #fff;\r\n    --bs-btn-bg: #358696;\r\n    --bs-btn-border-color: #358696;\r\n    --bs-btn-hover-color: #fff;\r\n    --bs-btn-hover-bg: #358696;\r\n    --bs-btn-hover-border-color: #358696;\r\n    --bs-btn-focus-shadow-rgb: 49, 132, 253;\r\n    --bs-btn-active-color: #fff;\r\n    --bs-btn-active-bg: #358696;\r\n    --bs-btn-active-border-color: #358696;\r\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\r\n    --bs-btn-disabled-color: #fff;\r\n    --bs-btn-disabled-bg: #358696;\r\n    --bs-btn-disabled-border-color: #358696;\r\n}\r\n\r\n.form-check-input:checked {\r\n    background-color: #358696;\r\n    border-color: #358696;\r\n}\r\n\r\n.form-select:focus {\r\n    border-color: #358696;\r\n    outline: 0;\r\n    box-shadow: 0 0 0 0.25rem rgb(53 134 150 / 23%);\r\n}\r\n\r\n/* Tabs Section */\r\n.nav-link:focus,\r\n.nav-link:hover {\r\n    /* color: var(--bs-nav-link-hover-color); */\r\n    color: #358696;\r\n}\r\n\r\n.nav-link {\r\n    color: #999;\r\n}\r\n\r\n.nav-tabs .nav-item.show .nav-link,\r\n.nav-tabs .nav-link.active {\r\n    color: #358696;\r\n    background-color: var(--bs-nav-tabs-link-active-bg);\r\n    border-color: var(--bs-nav-tabs-link-active-border-color);\r\n}\r\n\r\n/* Section Header<> */\r\n\r\n.secHead34 {\r\n    background-color: #d3eff4;\r\n    padding: 10px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.bg-white {\r\n    background-color: #fff;\r\n}\r\n\r\n.headBG {\r\n    box-sizing: border-box;\r\n    background: #FFFFFF;\r\n    border: 1px solid #358696;\r\n}\r\n\r\n.mainDiv {\r\n    margin-top: 80px;\r\n}\r\n\r\n.widget {\r\n    background: #FFFFFF;\r\n    box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.11);\r\n}\r\n\r\n.widgetIcon img {\r\n    width: 50px;\r\n    height: 50px;\r\n}\r\n\r\n.widgetIcon-32 img {\r\n    width: 32px;\r\n    height: 32px;\r\n}\r\n\r\n.sec2Charts .titlebg {\r\n    font-size: 1.1em;\r\n    color: #000;\r\n    font-weight: 500;\r\n    margin-bottom: 10px;\r\n    text-align: left;\r\n}\r\n\r\n.titlebg {\r\n    font-size: 1.2em;\r\n    color: #000;\r\n    font-weight: 500;\r\n    margin-bottom: 10px;\r\n    text-align: center;\r\n}\r\n\r\n.chart3Title {\r\n    font-size: 1.2em;\r\n    color: #000;\r\n    font-weight: 500;\r\n    text-align: left;\r\n}\r\n\r\n.chartbox {\r\n    background: #FFFFFF;\r\n    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\r\n    padding: 10px;\r\n    color: #353535;\r\n    /* font-size: 14px; */\r\n}\r\n\r\n.chartbox3 {\r\n    background: #FFFFFF;\r\n    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\r\n    padding: 10px;\r\n    color: #353535;\r\n    /* min-height: 495px; */\r\n}\r\n\r\nh5,\r\n.h5 {\r\n    font-size: 1.1rem !important;\r\n}\r\n\r\np {\r\n    line-height: 1rem !important;\r\n}\r\n\r\nsmall,\r\n.small {\r\n    font-size: 80% !important;\r\n}\r\n\r\ntable tr td {\r\n    font-size: 0.8em;\r\n}\r\n\r\n.accordion-button {\r\n    font-size: 0.5em;\r\n}\r\n\r\n.accordion-button:not(.collapsed) {\r\n    background-color: #e0e0e0;\r\n    color: #222;\r\n}\r\n\r\n.filterForm>.form-label {\r\n    font-size: 0.825em;\r\n}\r\n\r\n.form-label {\r\n    font-size: 0.825em;\r\n}\r\n\r\n.Headfont {\r\n    font-size: 1.8rem;\r\n}\r\n\r\n.dropdown-menu[data-bs-popper] {\r\n    right: 0 !important;\r\n    left: auto;\r\n}\r\n\r\n/***************************** PageTwo *******************************/\r\n.bt-graph {\r\n    border-right: solid 1px #b5b5b5;\r\n}\r\n\r\n.icon-rgt {\r\n    /* width: 62%; */\r\n    float: right;\r\n}\r\n\r\n.icon-rgt-top {\r\n    font-size: 13px;\r\n    width: 100%;\r\n    padding: 5px 0px 2px 0px;\r\n}\r\n\r\n.fst1 {\r\n    border-left: solid 2px #ffa650;\r\n    float: right;\r\n    margin-right: 10px;\r\n    padding-left: 5px;\r\n    font-size: 11px;\r\n}\r\n\r\n/* .icon-rgt-top {} */\r\n\r\n.fst {\r\n    border-left: solid 2px #ffa650;\r\n    padding-left: 5px;\r\n    /* font-size: 11px; */\r\n    font-size: 12px;\r\n}\r\n\r\n\r\n\r\n/* media queries start here */\r\n\r\n@media screen and (max-width: 991px) {\r\n    .mgt-2 {\r\n        margin-top: 20px;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 740px) {\r\n    .titlebg {\r\n        font-size: 0.9em;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 720px) {\r\n    .mainDiv {\r\n        margin-top: 124px;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 480px) {\r\n    .mainDiv {\r\n        margin-top: 155px;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 480px) {\r\n    .topHeader h2 {\r\n        font-size: 22px;\r\n        padding-right: 3rem;\r\n    }\r\n\r\n    .titlebg {\r\n        font-size: 0.9em;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 320px) {\r\n    .topHeader h2 {\r\n        font-size: 16px;\r\n        padding-right: 0rem;\r\n    }\r\n}\r\n\r\n.boxHead {\r\n    background: #D3EFF4;\r\n    border-bottom: 1px solid #358696;\r\n    padding: 5px;\r\n    height: 30px;\r\n    /* margin-bottom: 15px; */\r\n    margin-top: 5px;\r\n}\r\n\r\ndl dt {\r\n    display: inline-block;\r\n    width: 5px;\r\n    height: 15px;\r\n    vertical-align: middle;\r\n}\r\n\r\ndl dd {\r\n    display: inline-block;\r\n    margin: 0px 5px;\r\n    padding-bottom: 0;\r\n    vertical-align: middle;\r\n    font-size: 12px;\r\n}\r\n\r\ndl dt.red {\r\n    background: #ffa344;\r\n}\r\n\r\ndl dt.yellow {\r\n    background: #358696;\r\n}\r\n\r\n/* #chartdivBCS{\r\n    width: 100%;\r\n    height: 500px;\r\n} */\r\n.evfpr0{\r\n    padding-right: 0px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
